"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DRIVER_FIELD_MAX_LENGTH = void 0;
exports.DRIVER_FIELD_MAX_LENGTH = {
    SOURCE: 50,
    EXTERNAL_DRIVER_ID: 100,
    NAME: 200,
    LOGIN: 200,
    PIN: 100,
    DIN: 100,
};
//# sourceMappingURL=driverFieldMaxLength.js.map